// extracted by mini-css-extract-plugin
module.exports = {"noOrderContainer":"styles_noOrderContainer__W09Oj","noOrder":"styles_noOrder__8s9ZR"};